import React from "react";

import * as S from "./styles";

export const Home: React.FC = () => {
  return (
    <S.Container>
      <S.ScrollInfo>
        Role para avançar <S.IconChevron />
      </S.ScrollInfo>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
          >
            <span>o futuro</span>
            biotecnológico
            <span className="moda">da moda</span>
          </S.Title>
          <S.Text
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            <p>
              Até ontem, pensar em usar couro de cogumelo, algas marinhas e
              fluidos corporais para criar roupas parecia papo de um futuro
              distante. Mas diversas iniciativas provam que ele está acontecendo
              aqui e agora.
            </p>
            <p className="credit">Por João Rodolfo e Gustavo Kievel</p>
          </S.Text>
        </S.Wrapper>
      </S.Content>
      <S.Content
        className="right wow animate__animated animate__fadeIn"
        data-wow-duration="800ms"
        data-wow-delay="600ms"
      >
        <S.Photo />
      </S.Content>
    </S.Container>
  );
};
